const API_URL = `${process.env.REACT_APP_BACKOFFICE_API_URL}/api/v1/login`;
// const API_URL = 'http://localhost/one_backoffice/api/v1/login';
class AuthService {
  login(username, password, rememberMe) {
    return fetch(API_URL, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: username,
        password,
        remember_me: rememberMe,
      }),
    })
      .then(function(response) {

        if (response.status === 401) {
          return response.json();
        }

        if (response.status === 422) {
          throw new Error('ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง');
        }

        return response.json();

      })
      .then((response) => {
        if ( response.success !== undefined && response.success === false) {
          
          throw new Error(response.message);
        }
        if (response.data.token.access_token) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response;
      });
  }

  logout() {
    localStorage.removeItem('user');
    // setTimeout(() => {
    //   window.location.href = '/';
    // }, 2000);
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  getCurrentRole() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user !== null ? user.profile.user_type.id : false;
  }

  isLogin() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user !== null;
  }
}

export default new AuthService();
